import { TemplateGroup, TemplatePayload, UiWidget } from '@pt/pt-models';
import { JSONPath } from 'jsonpath-plus';
import { GetChapterResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/GetChapterResponse';
import { ChapterSelector } from 'it/primatoo/openapi/api/org/schemas/common/docs/ChapterSelector';
import { UpsertWidgetsRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/UpsertWidgetsRequest';
import { Widget } from 'it/primatoo/openapi/api/org/schemas/common/docs/Widget';

export class WidgetActionsUtils {

  public static execJsonPath(path, json): any | null {
    if (path && json) {
      try {
        return JSONPath({ path, json });
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  public static getWidgetFromChapter(c: GetChapterResponse, changedWidgetId: number[] | undefined): UiWidget[] {
    const response: UiWidget[] = [];
    if (changedWidgetId && c) {
      const localRecipe = c.payload as TemplatePayload;
      localRecipe?.groups?.forEach((templateGroup: TemplateGroup) => {
        templateGroup?.widgets?.forEach((w: UiWidget) => {
          if (changedWidgetId?.includes(w.internalId)) {
            response.push(w);
          }
        });
      });
    }
    return response;
  }

  static generateWidgetsUpsertRequest(widgets: UiWidget[], chapterSelector: ChapterSelector): UpsertWidgetsRequest {
    const request: UpsertWidgetsRequest = {
      widgets: widgets.map((w: UiWidget) => {
        const request: Widget = {
          internalId: w?.internalId,
          version: w.version,
          type: w.type,
          value: w.value,
          properties: w.properties,
          editable: w.editable,
          opt: w.opt,
          chapter: chapterSelector,
          enabled: w.enabled
        };
        return request;
      })
    };
    return request;
  }


  static forceSetSavedTrue(widgets: UiWidget[]): UiWidget[] {
    const response = JSON.parse(JSON.stringify(widgets)) as UiWidget[];
    response?.forEach(w => {
      w.saved = true;
    });
    return response;
  }


  static getWidgetFromTemplateGroups(groups: TemplateGroup[]): UiWidget[] {
    const widget: UiWidget[] = [];
    groups?.forEach((templateGroup: TemplateGroup) => {
      if (templateGroup.enabled) {
        templateGroup?.widgets?.forEach((w: UiWidget) => {
          if (w.enabled) {
            widget.push(w);
          }
        });
      }
    });
    return widget;
  }
}
